export const SHOW_NOTIFICATION = "showNotification"
export const SET_MESSAGE_TEXT = "setMessageText"

export const SET_USER = "setUser"

export const SET_SERIES = "setSeries"
export const SET_SERIE = "setSerie"
export const ADD_SERIES = "addSeries"
export const SET_SERIES_FILTER = "setSeriesFilter"

export const ADD_SERIES_MESSAGE_TEMPLATE = "addSeriesMessageTemplate"

export const ADD_SERIES_ASSIGNMENT = "addSeriesAssignment"

export const SET_MEMBERS = "setMembers"

export const SET_INBOX = "setInbox"
export const SET_MESSAGE= "setMessage"
